module.exports = __webpack_public_path__ + "img/1557614080876945409.2d236a7b.png";